import "core-js/modules/es.array.map";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ProductParametersListItemGroupParameter from '../ProductParametersListItemGroupParameter';
var useStyles = makeStyles(function (theme) {
  return {
    root: {},
    label: {
      paddingTop: theme.spacing(2)
    },
    tooltip: {
      alignItems: 'center',
      display: 'flex'
    },
    tooltipIcon: {
      color: theme.palette.primary.light,
      marginLeft: theme.spacing(1)
    }
  };
}, {
  name: 'SxComProductParametersListItemGroup'
});

function ProductParametersListItemGroup(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      helperText = _ref.helperText,
      label = _ref.label,
      parameters = _ref.parameters,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "helperText", "label", "parameters"]);

  var classes = useStyles({
    classes: pClasses
  });
  return (parameters || []).length === 0 ? null : /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label,
    variant: "h6",
    component: "div"
  }, helperText ? /*#__PURE__*/React.createElement("div", {
    className: classes.tooltip
  }, label, /*#__PURE__*/React.createElement(Tooltip, {
    title: helperText
  }, /*#__PURE__*/React.createElement(HelpIcon, {
    className: classes.tooltipIcon,
    fontSize: "small",
    color: "inherit"
  }))) : label), parameters.map(function (parameter) {
    return /*#__PURE__*/React.createElement(ProductParametersListItemGroupParameter, {
      key: parameter.code,
      parameter: parameter
    });
  }));
}

ProductParametersListItemGroup.propTypes = {
  classes: PropTypes.shape({
    label: PropTypes.string,
    root: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipIcon: PropTypes.string
  }),
  className: PropTypes.string,
  helperText: PropTypes.string,
  label: PropTypes.string.isRequired,
  parameters: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    label: PropTypes.string.isRequired,
    unit: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired
  }))
};
ProductParametersListItemGroup.defaultProps = {
  classes: undefined,
  className: undefined,
  helperText: undefined,
  parameters: undefined
};
export default ProductParametersListItemGroup;